module.exports = __webpack_public_path__ + "345d40f26856f6cdaaa44665dee33282.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/train/view/home/images/1.png
// module id = 177
// module chunks = 1